var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomitsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1544_22583",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C1.79086 0 0 1.79086 0 4V12.1253C0 14.3344 1.79086 16.1253 4 16.1253H12C14.2091 16.1253 16 14.3344 16 12.1253V4C16 1.79086 14.2091 0 12 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1544_22583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02118 0.000135517C8.02118 0.000210361 8.02112 0.000271034 8.02105 0.000271034H2.12221C1.38358 0.000271034 1.01443 0.89398 1.53774 1.41524C1.69297 1.56985 1.90313 1.65666 2.12221 1.65666H8.02118C9.7112 1.65666 11.332 2.32723 12.527 3.52087C13.722 4.7145 14.3934 6.33341 14.3934 8.02145C14.3934 9.70951 13.722 11.3284 12.527 12.522C11.332 13.7156 9.7112 14.3863 8.02118 14.3863H5.96039C5.28391 14.3863 4.94558 13.568 5.42453 13.0903C5.56678 12.9484 5.75948 12.8687 5.96038 12.8687H8.02227C9.30898 12.8687 10.543 12.3582 11.4528 11.4494C12.3627 10.5406 12.8739 9.30802 12.8739 8.02281C12.8739 6.7376 12.3627 5.50502 11.4528 4.59624C10.543 3.68746 9.30898 3.17691 8.02227 3.17691H5.34836C4.5926 3.17691 4.21446 4.09098 4.74935 4.6249C4.90834 4.78361 5.12381 4.87273 5.34846 4.87271L7.3552 4.87247L8.02118 4.87072C8.85809 4.87072 9.66072 5.2028 10.2525 5.79389C10.8443 6.38498 11.1767 7.18668 11.1767 8.02261C11.1767 8.85855 10.8443 9.66024 10.2525 10.2513C9.66072 10.8424 8.85809 11.1745 8.02118 11.1745H6.651C5.59084 11.1745 4.57404 11.5954 3.82401 12.3447L1.78066 14.386C1.16778 14.9981 1.60131 16.0456 2.46753 16.0456H8.02118C10.1514 16.0456 12.1945 15.2004 13.7008 13.6958C15.2071 12.1912 16.0533 10.1506 16.0533 8.02281C16.0533 5.89503 15.2071 3.8544 13.7008 2.34983C12.1945 0.845291 10.1515 3.58718e-05 8.02132 1.14175e-09C8.02124 -1.18551e-10 8.02118 6.06731e-05 8.02118 0.000135517Z",
    fill: "#0D9813"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomitsLogo);
export default __webpack_public_path__ + "static/media/domits-logo.bceddf08a928048471cc424444035f66.svg";
export { ForwardRef as ReactComponent };